module.exports = __webpack_public_path__ + "static/checklist-ccf42517ec14ca56b45e0ea2a94211aa.svg";